import React, { useEffect }  from 'react';
import { useLocation } from 'react-router-dom';
import '../../style/agentsList.css'
import '../../style/premiumList.css'
import SolicitorGroupHOC from '../../containers/SolicitorGroups/solicitorGroupHOC'
import PremiumSettingsWizardHOC from '../../containers/PremiumSettings/premiumSettingsWizardHOC'
import PremiumSettingsCombinationTable from "./premiumSettingsCombinationTable";
import { CANADA_COUNTRY, COUNTRY, LEGAL_ADVICE_TEXT, PREMIUM_SETTINGS_TABS, PERCENTAGE_PREMIUMS_AVAILABLE } from '../../helpers/variables';
import {HorizontalRule, NavigationBar, NavigationContent, Button, Loader, Alert, FormGroup, Heading} from 'arag-ui-lib'
import StagedPremiumSettingsCombinationTable from './stagedPremiumSettingsCombinationTable';
import StagedStep4 from './WizardSteps/stagedStep4';
import {clearSuccessMsg} from "../../helpers/utilMessage";
import { DOTS, HEADING_2, INITIAL_OPTIONS, MEDIUM, PRIMARY, PS_TYPE_CUSTOM, PS_TYPE_DEFAULT, PS_TYPE_PERCENTAGE, PS_TYPE_STAGED, QUATERNARY, REVERSE, RIGHT, SUCCESS, TERTIARY } from '../../helpers/constants';
import CONTENT_STRINGS from '../../helpers/contentStrings';
import { FORM_GROUP_VARIANTS } from '../../helpers/formGroupVariants';
import PremiumSettingsCopyFormModal from './premiumSettingsCopyFormModal';
import { formatSolicitorOptionLabel } from '../../helpers/functions';

const PremiumSettings = (props) => {

	const {
		isCopyModalOpen,
		openCopyModal,
		closeCopyModal,
		groupCaseAndSubTypes,
		getSolicitorGroupCaseTypes,
		requestGetSolicitorGroupWorkSources,
		createNewHandle,
		isCopyStagedModalOpen,
		toggleStagedCopyModal,
		changeNewPremiumStoreSettings,
		premiumSettings,
		handleSolGroupsChange,
		handleAllPremiumChange,
		handleAllStagedPremiumChange,
		editHandle,
		push,
		allPossibleDamages,
		caseTypes,
		subCaseTypes,
		stagedPremiums,
		amountColumnsDisplayDataPerStage,
		changepsType,
		viewEditForm,
		changeWorksource,
		fetchingCaseTypes,
		caseTypesRecords,
		subCaseTypesRecords,
		openModal,
		stepMessages,
		showNonContingentToggle
	} = props;
	const groupOptions = [...INITIAL_OPTIONS, ...premiumSettings.solicitorGroups.map((option) => {
		return {key: option.id.toString(), label: option.name, aragProvider: option.aragProvider}
	})];
	// The SearchableList variant used for the group picker below needs
	// value/label-shaped options (its own value/onChange contract), unlike the key/label
	// shape groupOptions uses for the native SELECT variant still relied on elsewhere in
	// this file (worksourcesOptions) and by PremiumSettingsCopyFormModal's groupOptions prop.
	// Built from solicitorGroups directly (not from groupOptions, which carries INITIAL_OPTIONS'
	// {key: '', label: ''} sentinel for the native <select>) with its own CONTENT_STRINGS.NONE
	// sentinel instead, matching the other converted SearchableList pickers - otherwise the blank
	// label rendered as an empty, clickable row above the real groups.
	// value is derived from option.id.toString() so this stays a string end-to-end, matching what
	// handleSolGroupsChange/selectedSolicitorGroup and every downstream comparison against it
	// (e.g. resolveSolicitorGroupAragProviderId, parseInt(selectedSolicitorGroup) call sites) have
	// always expected from the old native select's evt.target.value.
	const searchableGroupOptions = [{value: '', label: CONTENT_STRINGS.NONE}, ...premiumSettings.solicitorGroups.map((option) => {
		return {value: option.id.toString(), label: option.name, aragProvider: option.aragProvider}
	})];
	const worksourcesOptions = [{key: '', label: CONTENT_STRINGS.NONE}, ...premiumSettings.worksources.map((option) => {
		if(premiumSettings.worksources.length === 0) return [];
		return {key: option.id.toString(), label: option.name}
	})];
	const location = useLocation();
	const successMsg = location.state && location.state.successMsg;

	// Scrub successMsg from this history entry on mount, so a later in-app Back doesn't resurrect
	// the banner for a save several navigations ago.
	useEffect(() => {
		clearSuccessMsg(location);
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	// Belt-and-braces: re-subscribes on [location], so it also scrubs a successMsg set again on this
	// same mount (the mount effect above only runs once) if it's still there when the tab closes.
	useEffect(() => {
		const handleBeforeUnload = () => clearSuccessMsg(location);
		window.addEventListener('beforeunload', handleBeforeUnload);
		return () => {
			window.removeEventListener('beforeunload', handleBeforeUnload);
		};
	}, [location]);

	if (fetchingCaseTypes) {
		return (
			<div style={{ display: 'flex', justifyContent: 'center'}}>
				<Loader variant={DOTS} dotSize={MEDIUM} />
			</div>
		);
	}

	return (
		<div className="row">
			<div className="col-sm-12">
				<Heading 
					title={CONTENT_STRINGS.PREMIUM_SETTINGS} 
					variant={HEADING_2}
					headingTestId={'premium-settings-header'}
				/>
			</div>
			<div className="col-sm-12">
				<PremiumSettingsCopyFormModal
					isOpen={isCopyModalOpen}
					onClose={closeCopyModal}
					groupCaseAndSubTypes={groupCaseAndSubTypes}
					caseTypes={caseTypesRecords}
					subCaseTypes={subCaseTypesRecords}
					groupOptions={groupOptions}
					worksourcesOptions={worksourcesOptions}
					premiumSettingsId={premiumSettings.editingPremiumSettingId}
					getSolicitorGroupCaseTypes={getSolicitorGroupCaseTypes}
					requestGetSolicitorGroupWorkSources={requestGetSolicitorGroupWorkSources}
					changeNewPremiumStoreSettings={changeNewPremiumStoreSettings}
					stagedId={''}
					premiumSettingType={premiumSettings.psType}
				/>
				{
					isCopyStagedModalOpen 
					?
						<PremiumSettingsCopyFormModal
							isOpen={isCopyStagedModalOpen}
							onClose={toggleStagedCopyModal}
							groupCaseAndSubTypes={groupCaseAndSubTypes}
							caseTypes={caseTypesRecords}
							subCaseTypes={subCaseTypesRecords}
							groupOptions={groupOptions}
							worksourcesOptions={worksourcesOptions}
							premiumSettingsId={premiumSettings.editingPremiumSettingId}
							getSolicitorGroupCaseTypes={getSolicitorGroupCaseTypes}
							requestGetSolicitorGroupWorkSources={requestGetSolicitorGroupWorkSources}
							changeNewPremiumStoreSettings={changeNewPremiumStoreSettings}
							stagedId={stagedPremiums.stagedPremiumSetting?.id != undefined ? stagedPremiums.stagedPremiumSetting.id : '' }
							premiumSettingType={premiumSettings.psType}
						/>
					:
						null
				}
				{
					successMsg
					?
						<Alert variant={SUCCESS} label={successMsg}/>
					:
						null
				}
				{
					premiumSettings.openModal ?
						<div className="appFormRefSettings-modal">
							<div className="appFormRefSettings-modal-content">
								<div className="appFormRefSettings-close-button"
									onClick={() => changeNewPremiumStoreSettings('openModal', false)}></div>
								<SolicitorGroupHOC storeIsValid={true}/>
							</div>
						</div>
						:
						null
				}
				<div>
					<NavigationBar 
						onNavItemSelect={(key) => changepsType(key)} 
						activeItemKey={premiumSettings.psType} 
						navItems={PREMIUM_SETTINGS_TABS}
					/>
				</div>
				<div className="form-horizontal" >
					{
						premiumSettings.psType === PS_TYPE_CUSTOM ||
						premiumSettings.psType === PS_TYPE_STAGED || 
						(PERCENTAGE_PREMIUMS_AVAILABLE && premiumSettings.psType === PS_TYPE_PERCENTAGE)
						?
							<div style={{paddingTop:30}}>
								<Button 
									onClick={() => openModal(true)}
									variant={QUATERNARY}
									label={`Create New ${LEGAL_ADVICE_TEXT} Group`}
									arrowDirection={RIGHT}
									buttonTestId={'premium-settings-create-new-solicitor-group'}
								/>
								<HorizontalRule />

								<FormGroup
									labelSize={'col-sm-2'}
									inputSize={'col-sm-6'}
									label={`${LEGAL_ADVICE_TEXT} ${CONTENT_STRINGS.GROUP}`}
									variant={FORM_GROUP_VARIANTS.SEARCHABLE_LIST}
									inputProps={{
										required: true,
										instanceId: 'premiumSettingsSolicitorGroup',
										options: searchableGroupOptions,
										value: searchableGroupOptions.find(o => o.value === premiumSettings.selectedSolicitorGroup) || null,
										onChange: (option) => handleSolGroupsChange('selectedSolicitorGroup', option ? option.value : ''),
										formatOptionLabel: formatSolicitorOptionLabel,
									}}
									formGroupTestId={`premium-settings-solicitor-group-select`}
								/>
								{
									premiumSettings.selectedSolicitorGroup !== '' 
									?
										<FormGroup 
											labelSize={'col-sm-2'}
											inputSize={'col-sm-6'}
											label={CONTENT_STRINGS.WORK_SOURCE}
											variant={FORM_GROUP_VARIANTS.SELECT}
											inputProps={{
												onChange: (evt) => { 
													changeWorksource(evt); 
													viewEditForm(evt.target.name, evt.target.value); 
													handleAllPremiumChange('showAllPremiumSettingsForCombination', false);
													handleAllStagedPremiumChange('getAllStagedPremiumsForCombination',false);
												},
												value: premiumSettings.selectedWorksource,
												name: 'selectedWorksource',
												options: worksourcesOptions,
											}}
											formGroupTestId={`premium-settings-work-source-select`}
										/>
									:
										null
								}
							</div>
						: 
							<HorizontalRule />
					}
					{
						((premiumSettings.psType === PS_TYPE_CUSTOM || 
							premiumSettings.psType === PS_TYPE_STAGED || 
							(PERCENTAGE_PREMIUMS_AVAILABLE && premiumSettings.psType === PS_TYPE_PERCENTAGE)) &&
								premiumSettings.selectedSolicitorGroup !== '' ) ||
						premiumSettings.psType === PS_TYPE_DEFAULT 
						?
							<FormGroup
								labelSize={'col-sm-2'}
								inputSize={'col-sm-6'}
								label={CONTENT_STRINGS.CASE_TYPE}
								variant={FORM_GROUP_VARIANTS.SELECT}
								inputProps={{
									required: true,
									onChange: (evt) => {
										changeNewPremiumStoreSettings(evt.target.name, evt.target.value);
										viewEditForm(evt.target.name, evt.target.value);
										changeNewPremiumStoreSettings('selectedSubCaseType', '');
									},
									value: premiumSettings.selectedCaseType,
									name: 'selectedCaseType',
									options: caseTypes,
								}}
								formGroupTestId={'premium-settings-case-type-select'}
							/>
						:
							null
					}
					<HorizontalRule />
				</div>
				{
					subCaseTypes.length > 1 
					?
						<div className="premiumList-subCasesTabs-wrapper">
							<NavigationBar 
								onNavItemSelect={(subCase) => {
									changeNewPremiumStoreSettings('selectedSubCaseType', subCase.toString());
									viewEditForm('selectedSubCaseType', subCase.toString());
								}}
								activeItemKey={premiumSettings.selectedSubCaseType === '0' ||
									premiumSettings.selectedSubCaseType === '' 
										? '0'
										: premiumSettings.selectedSubCaseType
								}
								navItems={
									subCaseTypes.map((subCase, index) => {
										return { 
											key: index == 0 ? '0' : `${subCase.key}`,
											label: (subCase.value ? subCase.value : CONTENT_STRINGS.DEFAULT),
											navItemTestId: `premium-settings-sub-case-tab-${subCase.machineName}`
										}
									})
								}
							/>
						</div>
					:
						null
				}
				{
					premiumSettings.selectedCaseType !== '' && premiumSettings.psType !== PS_TYPE_STAGED 
					?
						<div className='custom-reverse-checkbox'>
							<FormGroup
								inputSize={'col-sm-1'}
								labelSize={'col-sm-2 custom-label'}
								label={CONTENT_STRINGS.SHOW_ALL}
								variant={FORM_GROUP_VARIANTS.CHECKBOX}
								groupShape={REVERSE}
								inputProps={{
									onChange: (evt) => {handleAllPremiumChange(evt.target.name, evt.target.checked);},
									id: 'showAllPremiumSettingsForCombination',
									name: 'showAllPremiumSettingsForCombination',
									checked: premiumSettings.showAllPremiumSettingsForCombination,
								}}
								formGroupTestId={'premium-settings-show-all'}
							/>
						</div>
					:
						null
				}
				{
					premiumSettings.selectedCaseType !== '' &&
					premiumSettings.psType === PS_TYPE_STAGED &&
					stagedPremiums?.fetchingCurrent == false &&
					stagedPremiums?.fetchingAllForCombination == false 
					?
						<div className='custom-reverse-checkbox'>
							<FormGroup
								inputSize={'col-sm-1'}
								labelSize={'col-sm-2 custom-label'}
								label={CONTENT_STRINGS.SHOW_ALL}
								variant={FORM_GROUP_VARIANTS.CHECKBOX}
								groupShape={REVERSE}
								inputProps={{
									onChange: (evt) => { handleAllStagedPremiumChange(evt.target.name,evt.target.checked) },
									id: 'getAllStagedPremiumsForCombination',
									name: 'getAllStagedPremiumsForCombination',
									checked: stagedPremiums.getAllStagedPremiumsForCombination,
								}}
								formGroupTestId={'staged-premium-settings-show-all'}
							/>
						</div>
					: 
						null
				}
				{
					premiumSettings?.allPremiumSettingsForCombination?.length > 0 &&
					premiumSettings.psType !== PS_TYPE_STAGED 
					?
						<PremiumSettingsCombinationTable
							push={push}
							psType={premiumSettings.psType}
							changeNewPremiumStoreSettings={changeNewPremiumStoreSettings}
							allPossibleDamages={allPossibleDamages}
							data={premiumSettings.allPremiumSettingsForCombination}
							stepMessages={stepMessages}
							selectedCaseType={premiumSettings.selectedCaseType}
							caseTypesRecords={caseTypesRecords}
							isApplicationPremium={false}
        					topHeader={CONTENT_STRINGS.DAMAGES}
        					isPercentagePremium={premiumSettings.psType === PS_TYPE_PERCENTAGE}
        					showTable={true}
							showNonContingentToggle={showNonContingentToggle}
						/>
					:
						null
				}
				{
					stagedPremiums.allStagedPremiumSetting.length > 0 &&
					stagedPremiums.getAllStagedPremiumsForCombination == true &&
					premiumSettings.psType === PS_TYPE_STAGED 
					?
						// PREVIEWS
						<StagedPremiumSettingsCombinationTable
							amountColumnsDisplayDataPerStage={amountColumnsDisplayDataPerStage}
							push={push}
							allStagedPremiums={stagedPremiums.allStagedPremiumSetting}
						/>
					:
						null
				}
				{
					<div  style={{ display: 'flex', flexDirection: 'row', gap: '20px'}}>
					{
						(
							!premiumSettings.showAllPremiumSettingsForCombination && 
							(premiumSettings.selectedCaseType !== '') &&
							stagedPremiums.getAllStagedPremiumsForCombination == false &&
							stagedPremiums?.fetchingCurrent == false &&
							stagedPremiums?.fetchingAllForCombination == false
						)
						?
							<>
								{
									(!premiumSettings.fetchingPremiumWithCombination && premiumSettings.showTable)
									?
										<Button
											onClick={openCopyModal}
											variant={PRIMARY}
											label={CONTENT_STRINGS.CREATE_NEW_BASED_ON_CURRENT}
											arrowDirection={RIGHT}
											buttonTestId={'premium-settings-setting-create-new-from-current'}
										/>
									:
										null
								}
								{
									(
										premiumSettings.psType === PS_TYPE_STAGED
										&& stagedPremiums?.fetchingCurrent == false
										&& stagedPremiums?.fetchingAllForCombination == false
										&& stagedPremiums.getAllStagedPremiumsForCombination == false
										&& stagedPremiums?.stagedPremiumSetting?.id != undefined
									)
									?
										<Button
											onClick={toggleStagedCopyModal}
											variant={PRIMARY}
											label={CONTENT_STRINGS.CREATE_NEW_BASED_ON_CURRENT}
											arrowDirection={RIGHT}
											buttonTestId={'staged-premium-settings-create-new-from-current'}
										/>
									:
										null
								}
								<Button
									onClick={createNewHandle}
									variant={TERTIARY}
									label={CONTENT_STRINGS.CREATE_NEW}
									arrowDirection={RIGHT}
									buttonTestId={'premium-settings-setting-create-new'}
								/>
								{
									!premiumSettings.fetchingPremiumWithCombination &&
									stagedPremiums?.fetchingCurrent == false &&
									stagedPremiums?.fetchingAllForCombination == false &&
									(premiumSettings.showTable || (
										stagedPremiums?.stagedPremiumSetting?.id != undefined &&
										stagedPremiums.getAllStagedPremiumsForCombination == false))
									?
										<Button 
											onClick={editHandle}
											variant={QUATERNARY}
											arrowDirection={RIGHT}
											label={CONTENT_STRINGS.EDIT}
											buttonTestId={'premium-settings-setting-edit'}
										/>
									:
										null
								}
							</>
						:
							null
					}
				</div>
				}
				{
					(premiumSettings.fetchingPremiumWithCombination || premiumSettings.fetchingAllPremiumsWithCombination || 
					stagedPremiums?.fetchingCurrent || stagedPremiums?.fetchingAllForCombination) 
					?
						<div style={{ display: 'flex', justifyContent: 'center'}}>
							<Loader variant={DOTS} dotSize={MEDIUM} />
						</div>
					:
						<NavigationContent>
							{
								(premiumSettings.psType === PS_TYPE_CUSTOM || 
								premiumSettings.psType === PS_TYPE_DEFAULT || 
								premiumSettings.psType === PS_TYPE_PERCENTAGE) &&
								premiumSettings.showTable 
								?
									<PremiumSettingsWizardHOC showTable={true} />
								:
									(premiumSettings.psType === PS_TYPE_STAGED && COUNTRY == CANADA_COUNTRY &&
									stagedPremiums?.stagedPremiumSetting?.id != undefined &&
									premiumSettings?.selectedCaseType !== '' &&
									stagedPremiums?.allStagedPremiumSetting?.length == 0 &&
									stagedPremiums?.getAllStagedPremiumsForCombination == false)
									?
										<StagedStep4
											amountColumnsDisplayDataPerStage={amountColumnsDisplayDataPerStage}
											isApplicationPremium={false}
											stagesSubSettings={stagedPremiums.stagedPremiumSetting?.stagedPremiumSubSettings}
											stagedPremiumData={stagedPremiums.stagedPremiumSetting}
											currentStep={4}
										/>
									:
										null
							}
						</NavigationContent>
				}
			</div>
		</div>
	)
};

export default PremiumSettings
